module.exports = __webpack_public_path__ + "static/img/scene_photo_sports.f9abc43.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/scene_photo_sports.jpg
// module id = xH/X
// module chunks = 1